import styled from "styled-components";

export const IndicatorIconWrapperDefaultBox = styled.div<{active?: boolean}>`
    color: ${({theme, active}) => active ? theme.colors.textLight : theme.colors.textMiddleDark };
`;
